import axios from 'axios';
import api from './api.js';

export default csrf_token => {
  // Indicate to the API that all requests for this app are AJAX
  axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

  // Set the baseURL for all requests to the API domain instead of the current domain
  axios.defaults.baseURL = api.url;

  // Allow the browser to send cookies to the API domain (which include auth_token)
  axios.defaults.withCredentials = true;
  axios.defaults.headers.common['x-csrf-token'] = csrf_token;
  //axios.defaults.headers.common['x-csrf-token'] = csrf_token;

  return axios;
};
